import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Layout from './components/Layout';
import Home from './pages/Home';
import SocialMediaManagement from './pages/SocialMediaManagement';
import Consulting from './pages/Consulting';
import About from './pages/About';
import Contact from './pages/Contact';
import PetContentPlanner from './pages/PetContentPlanner';
import LeadFunnelScore from './pages/LeadFunnelScore';
import Links from './pages/Links';
import AdBudgetCalculator from './pages/AdBudgetCalculator';
import PricingCalculator from './pages/PricingCalculator';
import OnyxCaseStudy from './pages/OnyxCaseStudy';
import Audit from './pages/Audit';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          {/* Main Website Routes with Header/Footer */}
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Navigate to="/services/social-media-management" replace />} />
            <Route path="/services/social-media-management" element={<SocialMediaManagement />} />
            <Route path="/services/consulting" element={<Consulting />} />
            <Route path="/pet-content-planner" element={<PetContentPlanner />} />
            <Route path="/lead-funnel-score" element={<LeadFunnelScore />} />
            <Route path="/ad-budget-calculator" element={<AdBudgetCalculator />} />
            <Route path="/pricing-calculator" element={<PricingCalculator />} />
            <Route path="/onyx-case-study" element={<OnyxCaseStudy />} />
            <Route path="/audit" element={<Audit />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
          </Route>

          {/* Standalone Landing Pages (No Header/Footer) */}
          <Route path="/links" element={<Links />} />
          <Route path="/bio" element={<Navigate to="/links" replace />} />
          
          {/* External Redirects */}
          <Route path="/audit-external" element={<Navigate to="/audit" replace />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;